import { CcdBoutonModel } from '@cnaf.usagers.appli/cnaf-commons-dral/lib/techniques/ccd-boutons-radio/ccd-bouton.model';


export class ProprietesQuestionsSitProModel {

    libelleQuestionSituation : string;
    reponsesQuestionSituation : Array<CcdBoutonModel>;

    libelleQuestionActiviteProfessionnelle : string;
    reponsesQuestionActiviteProfessionnelle : Array<CcdBoutonModel>;

    libelleQuestionChomage : string;
    reponsesQuestionChomage : Array<CcdBoutonModel>;

    libelleQuestionIndemnise : string;
    reponsesQuestionIndemnise : Array<CcdBoutonModel>;
}
